import React, { useEffect, useState } from 'react'
import "./banner.css";
import { BASE_URL } from '../../Components/Base_url/Base_Url';
import Loader from '../../Components/Base_url/Loader';

function Banner({ SegmentD, Serviceloading, slug }) {
    console.log("SegmentD:", SegmentD);
    return (
        <section
            className="about-banner"
            // style={{
            //     backgroundImage: SegmentD && SegmentD.length > 0 ? `url${BASE_URL}/${SegmentD[0]?.banner_img}` : `url("/Imges/raj.png")`,
            // }}
            style={{
                backgroundImage: SegmentD?.length > 0
                    ? `url(${BASE_URL}${SegmentD[0].banner_img})`
                    : `url("/Imges/raj.png")`,
            }}

        >


            <div className="about-banner-overlay">
                <div className="about-banner-content">
                    <h1>{SegmentD[0]?.name}</h1>
                    <p>
                        {SegmentD[0]?.remarks}
                    </p>

                    <h5><a href="/">Home</a>/{SegmentD[0]?.name}</h5>

                </div>
            </div>
        </section>
    );
}

export default Banner;
